import { createApp } from 'vue'
import App from './App.vue'
import './style/style.css'
import router from './router'
import mixpanelPlugin from './plugins/mixpanel'
import i18nPlugin from './plugins/i18n'

const app = createApp(App)
app.use(router)
app.use(mixpanelPlugin)
app.use(i18nPlugin)
app.mount('#app')
